import { mapState } from "vuex";
import { followupDemand, cancelDemand, demandSuspend } from "@/api/user";
export const followup = {
    data() {
        return {
            confirmLoading: false,
            cancelLoading: false,
            suspendLoading: false,
            indexLoading: 0
        }
    },
    computed: {
        ...mapState(["followupConfigs"]),
    },
    methods: {
        reqLoading(target) {
            const { index = 0 } = target.dataset
            if (index > 0) {
                this.indexLoading = index;
            }
        },
        reqLoaded() {
            this.indexLoading = 0;
        },
        demandConfirm(e, demandID, fn) {
            const that = this;
            const target = e.currentTarget
            that.reqLoading(target);
            const message = that.followupConfigs
                ? `跟进成功，已为您扣除${that.followupConfigs.join}积分`
                : "跟进成功，感谢您的参与。";
            followupDemand({
                demandID,
            })
                .then((res) => {
                    const { data } = res;
                    that.$message({
                        type: "success",
                        message: message,
                    });
                    if (Object.prototype.toString.call(fn) === '[object Function]') {
                        fn(data);
                    }
                })
                .finally(() => {
                    that.confirmLoading = false;
                    that.reqLoaded();
                });
        },
        cancelDemand(e, followID, fn) {
            const that = this;
            const target = e.currentTarget
            that
                .$confirm("项目需求与公司业务不匹配或现有信息无跟进价值，可以取消跟进。取消跟进后该需求不会出现在您的跟进列表里，但已扣减积分不会返回。", "警告", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    that.reqLoading(target)
                    that.cancelLoading = true;
                    cancelDemand({
                        followID,
                    })
                        .then((res) => {
                            const { data } = res.data;
                            if (Object.prototype.toString.call(fn) === '[object Function]') {
                                fn(data);
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                        })
                        .finally(() => {
                            that.cancelLoading = false;
                            that.reqLoaded()
                        });
                }).catch(() => {
                    that.cancelLoading = false;
                    that.reqLoaded()
                });
        },
        suspendDemand(e, demandID, followID, fn) {
            const that = this;
            const target = e.currentTarget
            that.
                $confirm("项目跟进过程受阻或项目变化导致已无法推进项目。项目终止后项目信息及过往跟进记录依然保留，方便业务人员复盘查看。已扣减积分不会返回。", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(() => {
                    that.reqLoading(target)
                    that.suspendLoading = true;
                    demandSuspend(demandID, followID)
                        .then((res) => {
                            const { data } = res.data;
                            if (Object.prototype.toString.call(fn) === '[object Function]') {
                                fn(data);
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                        })
                        .finally(() => {
                            that.suspendLoading = false;
                            that.reqLoaded()
                        });
                }).catch(() => {
                    that.suspendLoading = false;
                    that.reqLoaded()
                });
        }
    }
}